import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Paper, Tabs, Tab } from '@material-ui/core';
import TabPanel from './TabPanel';
import Detail from './detail/Detail';
import { useDetailTabsStyles } from './styles';

const DetailTabs = ({ ...props }) => {
  const { row, instructions, mobile } = props;
  const classes = useDetailTabsStyles({ mobile });
  const [value, setValue] = useState(0);
  const [instructionsToShow, setInstructionsToShow] = useState([]);
  const [tabsToShow, setTabsToShow] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (!instructions) setInstructionsToShow([]);
    else {
      if ('webCategoryInstructions' in instructions) {
        setInstructionsToShow([
          instructions.webCategoryInstructions,
          instructions.categoryInstructions,
        ]);
        setTabsToShow([
          { label: 'Usar en Ripley.com' },
          { label: 'Usar en tienda' },
        ]);
      } else {
        setInstructionsToShow([instructions.categoryInstructions]);
        setTabsToShow([{ label: 'Código' }]);
      }
    }
  }, [instructions]);

  return (
    <Paper elevation={0} className={classes.container}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabs}
      >
        {tabsToShow.length > 0 &&
          tabsToShow.map((tabToShow, index) => (
            <Tab
              key={index}
              label={tabToShow.label}
              data-cy={`tabDetail${index}`}
              className={classes.tab}
            />
          ))}
      </Tabs>
      {instructionsToShow.length > 0 &&
        instructionsToShow.map((instruction, index) => (
          <TabPanel key={index} value={value} index={index}>
            <Detail
              row={row}
              instructions={instruction}
              index={index}
              mobile={mobile}
            />
          </TabPanel>
        ))}
      {instructionsToShow.length === 0 && (
        <Detail row={row} instructions={[]} mobile={mobile} />
      )}
    </Paper>
  );
};

DetailTabs.propTypes = {
  row: PropTypes.object,
  instructions: PropTypes.object,
  mobile: PropTypes.bool,
};

export default DetailTabs;
